// D-1011 (ひろ 2026-10-08 承認): 画面のボタン・表示に使っていた絵文字(🏷 🔒 📝 🔄 📡 💾 ✏️ ❌ 📋 ▲▼ ＋)を線のアイコンへ。
// 出典: Lucide (https://lucide.dev) — ISC License (Copyright (c) Lucide Contributors)。
//   形は lucide-static v0.460.0 の SVG からそのまま(NavIcons.jsx と同じ版)。
//   save-off だけ v0.460 に viewBox の外へはみ出す余計な 1 本(M29.5 11.5…)があるため、それを除いた現行版(v1.52)の形。
//   ★新しいアイコンは Lucide から取る(ひろ 2026-10-08)。パスをコピーし、NavSvg(24 / stroke 2 / round / currentColor)で包む。
//   ★lucide-react は入れない。色はボタンの文字色(currentColor)を継ぐ。svg に data-icon を付けるのでテストはそれで見る。
//   ★refresh-cw / triangle-alert / package-x / gift は報告種別アイコン(src/components/icons/alertSilhouettes.jsx)に既にあるので、
//     そちらを使う(同じパスを 2 か所に持たない)。shared は components を import できないため、ここには置かない。
//   ★chevron(上下左右)・矢印は ChevronIcons.jsx(D-1012)にまとめてある。ここには置かない。
import React from 'react'
import { NavSvg } from './NavIcons'

/** ボタンの中で名前と並べるときの一辺(px)。 */
export const UI_ICON_PX = 16

function make(name, children) {
  function Icon({ size = UI_ICON_PX, className }) {
    return <NavSvg name={name} size={size} className={className}>{children}</NavSvg>
  }
  Icon.displayName = `UiIcon(${name})`
  return Icon
}

/** 資産タグ — lucide: tag */
export const TagIcon = make('tag', <>
  <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
  <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
</>)

/** ロッカー・権限なし — lucide: lock */
export const LockIcon = make('lock', <>
  <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
</>)

/** 報告 — lucide: message-square-warning */
export const MessageSquareWarningIcon = make('message-square-warning', <>
  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  <path d="M12 7v2" />
  <path d="M12 13h.01" />
</>)

/** リセット — lucide: rotate-ccw */
export const RotateCcwIcon = make('rotate-ccw', <>
  <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
  <path d="M3 3v5h5" />
</>)

/** 新規 — lucide: plus */
export const PlusIcon = make('plus', <>
  <path d="M5 12h14" />
  <path d="M12 5v14" />
</>)

/** 減らす — lucide: minus(D-1027 有休の消化日数) */
export const MinusIcon = make('minus', <>
  <path d="M5 12h14" />
</>)

/** 通信エラー — lucide: wifi-off */
export const WifiOffIcon = make('wifi-off', <>
  <path d="M12 20h.01" />
  <path d="M8.5 16.429a5 5 0 0 1 7 0" />
  <path d="M5 12.859a10 10 0 0 1 5.17-2.69" />
  <path d="M19 12.859a10 10 0 0 0-2.007-1.523" />
  <path d="M2 8.82a15 15 0 0 1 4.177-2.643" />
  <path d="M22 8.82a15 15 0 0 0-11.288-3.764" />
  <path d="m2 2 20 20" />
</>)

/** 保存失敗 — lucide: save-off */
export const SaveOffIcon = make('save-off', <>
  <path d="M13 13H8a1 1 0 0 0-1 1v7" />
  <path d="M14 8h1" />
  <path d="M17 21v-4" />
  <path d="m2 2 20 20" />
  <path d="M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41" />
  <path d="M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15" />
</>)

/** 入力を確認 — lucide: pencil */
export const PencilIcon = make('pencil', <>
  <path d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
  <path d="m15 5 4 4" />
</>)

/** エラー — lucide: circle-x */
export const CircleXIcon = make('circle-x', <>
  <circle cx="12" cy="12" r="10" />
  <path d="m15 9-6 6" />
  <path d="m9 9 6 6" />
</>)

/** 未対応の報告 — lucide: clipboard-list */
export const ClipboardListIcon = make('clipboard-list', <>
  <rect width="8" height="4" x="8" y="2" rx="1" ry="1" />
  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
  <path d="M12 11h4" />
  <path d="M12 16h4" />
  <path d="M8 11h.01" />
  <path d="M8 16h.01" />
</>)

/** 景品名の検索窓(D-1026) — lucide: search */
export const SearchIcon = make('search', <>
  <circle cx="11" cy="11" r="8" />
  <path d="m21 21-4.3-4.3" />
</>)

/** 確認済み(D-1026) — lucide: circle-check */
export const CircleCheckIcon = make('circle-check', <>
  <circle cx="12" cy="12" r="10" />
  <path d="m9 12 2 2 4-4" />
</>)

/** ロッカーの写真を撮る(D-1103) — lucide: camera */
export const CameraIcon = make('camera', <>
  <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
  <circle cx="12" cy="13" r="3" />
</>)
